import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import elEn from 'element-ui/lib/locale/lang/en'
import elZh from 'element-ui/lib/locale/lang/zh-CN'
import zh from './locales/zh'
import en from './locales/en'

Vue.use(VueI18n)

const LANG_KEY = 'tool_lang'

export function detectLang() {
  const saved = localStorage.getItem(LANG_KEY)
  if (saved === 'zh' || saved === 'en') return saved
  return (navigator.language || '').toLowerCase().startsWith('en') ? 'en' : 'zh'
}

const i18n = new VueI18n({
  locale: detectLang(),
  fallbackLocale: 'zh',
  messages: {
    zh: { ...zh, ...elZh },
    en: { ...en, ...elEn }
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

// Element UI 内置组件文案跟随
ElementLocale.i18n((key, value) => i18n.t(key, value))

export function getLanguage() {
  return i18n.locale
}

export function setLanguage(lang) {
  const l = lang === 'en' ? 'en' : 'zh'
  i18n.locale = l
  localStorage.setItem(LANG_KEY, l)
  document.documentElement.setAttribute('lang', l === 'en' ? 'en' : 'zh-CN')
}

// 初始化 html lang 属性
document.documentElement.setAttribute('lang', i18n.locale === 'en' ? 'en' : 'zh-CN')

export default i18n
